import { Container } from './Container';

export function ResultsStrip() {
  return (
    <section aria-label="Real results" className="sf-section sf-section-proof py-3 sm:py-4">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-sm font-semibold text-gch-text-secondary">
            Real test: <span className="text-gch-accent">1,961 plays</span> &bull; <span className="text-gch-accent">47% completion</span> &bull; <span className="text-gch-accent">43 CTA clicks</span>.
            <span className="block sm:inline sm:ml-1 text-gch-text-muted font-normal">From a 4k-follower IG account. No paid promo.</span>
          </p>
        </div>
      </Container>
    </section>
  );
}
